import { HttpInterceptorFn } from '@angular/common/http';
import { getAuthToken } from '../helpers/auth-storage.helper';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = getAuthToken();

  if (token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(cloned);
  }

  return next(req);
};
